<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  export let label = '';
  export let expandSpeedInPx = 1200;
  export let expanded = false;
  export let height = 0;

  $: duration = height / expandSpeedInPx;

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);

  const responsiveVars = new ResponsiveVars()
    .addFluid('dropdown-menu-inner-pt', toFluidVarInput(21, 30))
    .addFluid('dropdown-menu-inner-pb', toFluidVarInput(21, 21))
    .addFluid('dropdown-menu-inner-pt-mobile-reskin', toFluidVarInput(4.5, 9))
    .toCSS();
</script>

<div
  class={cx(responsiveVars, 'dropdown-menu', { expanded: expanded, reskin: brandReskinEnabled })}
  id={`${label}-dropdown-menu`}
  style={`--height: ${height}px; --duration: ${duration}s;`}
>
  <div class="dropdown-menu-divider" />
  <div
    class="dropdown-menu--inner"
    bind:clientHeight={height}
    aria-label={`${label} dropdown menu`}
  >
    <slot />
  </div>
</div>

<style lang="scss">
  @import 'src/scss/media';

  .dropdown-menu {
    height: 0px;
    overflow-y: hidden;
    transition: all var(--duration) var(--twist-ease-out-1);
    font-size: inherit;
    text-transform: inherit;
    font-weight: inherit;
    line-height: inherit;
    font-family: inherit;
    background-color: inherit;
    color: inherit;

    @include at(lg) {
      overflow-y: visible;
    }

    &.expanded {
      height: var(--height);
    }

    .dropdown-menu-divider {
      display: none;

      @include at(lg) {
        display: block;
        margin: 0;
        width: 100%;
        border-top: 1px solid rgba(0, 0, 0, 0.3);
      }
    }

    .dropdown-menu--inner {
      padding: var(--dropdown-menu-inner-pt) 0 var(--dropdown-menu-inner-pb) 0;
    }
  }

  .dropdown-menu.reskin {
    .dropdown-menu-divider {
      border-top: none;
    }

    .dropdown-menu--inner {
      padding: var(--dropdown-menu-inner-pt-mobile-reskin) 0 0 0;

      @include at(lg) {
        padding: var(--dropdown-menu-inner-pt) 0 var(--dropdown-menu-inner-pb) 0;
      }
    }
  }
</style>
